"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditNewPage = exports.FormEditNewPageConfig = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var theme_1 = require("../components/theme");
var mithril_1 = require("../mithril");
var form_designer_1 = require("../modules/form.designer/form.designer");
var services_1 = require("../services");
var form_edit_page_1 = require("./form.edit.page");
var page_1 = require("./page");
var CSS = {
    container: 'c-FormEdit'
};
var Style = (_a = {},
    _a[CSS.container] = {
        height: '100%',
        width: '80%'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.FormEditNewPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formNew,
    path: '/form/new',
    auth: {
        required: true
    }
};
var FormEditNewPage = /** @class */ (function (_super) {
    tslib_1.__extends(FormEditNewPage, _super);
    function FormEditNewPage() {
        return _super.call(this, exports.FormEditNewPageConfig) || this;
    }
    FormEditNewPage.prototype.init = function () {
        this.form = new core_shared_1.FormModel();
        this.designer = new form_designer_1.FormDesigner();
        this.designer.setEditing(true);
        this.designer.setForm(this.form);
    };
    Object.defineProperty(FormEditNewPage.prototype, "nodes", {
        get: function () {
            if (services_1.Services.Department.current == null) {
                return null;
            }
            if (this.designer == null) {
                this.init();
            }
            var userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
            if (!services_1.Services.UserProfile.canEditForms(userProfile)) {
                return null;
            }
            return (0, mithril_1.m)('div', { className: "".concat(form_edit_page_1.CSS.container, " ").concat(CSS.container), key: 'new-form' }, this.designer.view());
        },
        enumerable: false,
        configurable: true
    });
    FormEditNewPage.prototype.onRemove = function () {
        if (this.designer != null) {
            this.designer.onRemove();
            this.designer = null;
        }
    };
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], FormEditNewPage.prototype, "designer", void 0);
    return FormEditNewPage;
}(page_1.IkePage));
exports.FormEditNewPage = FormEditNewPage;
//# sourceMappingURL=form.edit.new.page.js.map